import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInfoPaneItemDefaultStyle } from './styles/info-pane-item-default-style';

export const InfoPaneItemDefault = ({
  name,
  value,
}) => {
  const classes = useDefaultStyles(getInfoPaneItemDefaultStyle);

  return (
    <div className={classes.contentItem}>
      <div className={classes.contentName}>{name}</div>
      <div className={classnames(classes.contentValue, 'info-value')}>{value}</div>
    </div>
  );
};

InfoPaneItemDefault.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
